import {pageInfo,collectionSubmit, collectionDetails,paymentSummaryExport, exportData, selfProductionCertificateExport, collectionBatchSubmit, invoicingExport, collectionRollback} from '../api';
import {goodsCategory, plant} from "../../../../../api";

const collectionConfirm = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    collectionObj: null,
    collectionBatchSubmitObj: null,
    collectionDetailsObj: null,
    exportObj: [],
    summaryExportObj: [],
    selfProductionCertificateObj: [],
    invoicingObj: [],
    collectionRollbackObj: {}
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = (data.obj || []).map(item=>({...item, btns:[item.collectionStatus == '未结算' ? false : true,true]}));
    },
    GOODS_CATEGORY(state, data) {
      state.goodsCategoryObj = data;
    },
    PLANT(state, data) {
      state.plantObj = data;
    },
    COLLECTION_SUBMIT(state, data){
      state.collectionObj = data;
    },
    COLLECTION_BATCH_SUBMIT(state, data){
      state.collectionBatchSubmitObj = data;
    },
    COLLECTION_DETAILS(state, data) {
      state.collectionDetailsObj = data;
    },
    SUMMARY_EXPORT_DATA(state, data) {
      state.summaryExportObj = data;
    },
    EXPORT_DATA(state, data) {
      state.exportObj = data;
    },
    SELF_PRODUCTION_CERTIFICATE(state, data) {
      state.selfProductionCertificateObj = data;
    },
    INVOICING_EXPORT(state, data) {
      state.invoicingObj = data;
    },
    COLLECTION_ROLLBACK(state, data) {
      state.collectionRollbackObj = data;
    },
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    async goodsCategory({commit}, obj) {
      let resp = await goodsCategory(obj);
      commit('GOODS_CATEGORY', resp);
    },
    async plant({commit}, obj) {
      let resp = await plant(obj);
      commit('PLANT', resp);
    },
    async collectionSubmit({commit}, obj){
      let result = await collectionSubmit(obj);
      commit('COLLECTION_SUBMIT', result);
    },
    async collectionBatchSubmit({commit}, obj){
      let result = await collectionBatchSubmit(obj);
      commit('COLLECTION_BATCH_SUBMIT', result);
    },
    //查询详情
    async collectionDetails({commit}, obj){
      let result = await collectionDetails(obj);
      commit('COLLECTION_DETAILS', result);
    },
    async paymentSummaryExport({commit}, obj) {
      let resp = await paymentSummaryExport(obj);
      commit('SUMMARY_EXPORT_DATA', resp);
    },

    async exportData({commit}, obj) {
      let resp = await exportData(obj);
      commit('EXPORT_DATA', resp);
    },

    async selfProductionCertificateExport({commit}, obj) {
      let resp = await selfProductionCertificateExport(obj);
      commit('SELF_PRODUCTION_CERTIFICATE', resp);
    },
    async invoicing({commit}, obj) {
      let resp = await invoicingExport(obj);
      commit('INVOICING_EXPORT', resp);
    },
    async collectionRollback({commit}, obj) {
      let resp = await collectionRollback(obj);
      commit('COLLECTION_ROLLBACK', resp);
    },
  }
}
export default collectionConfirm



// WEBPACK FOOTER //
// ./src/page/bd/run/collectionConfirm/store/collectionConfirm.store.js